/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React from "react";
import { Row, Col, Button, Table } from "antd";
import constantsMsgs from "../../../constants/messages";
import appLogo from "../../../assests/images/smcsLogo.svg";

import {
  camelCase,
  capitalise,
  capitaliseWithHyphen,
  formatDateTimeGlobal,
} from "../../../utils";
import "../style.scss";
import ServiceSummary from "./ServiceSummary";
import ServiceNonDox from "../NonDox/ServiceNonDox";

const Dox = ({ allAppData, bookingType, creditCharges }) => {
  let addressDetails = allAppData?.addressDetails;
  let returnAddress = allAppData?.returnAddressDetail;

  const senderAddressData = `
  ${
    addressDetails?.senderAddressLine1 ? addressDetails.senderAddressLine1 : ""
  }${" "}
  ${
    addressDetails?.senderAddressLine2 ? addressDetails?.senderAddressLine2 : ""
  }${" "}
  `;

  const receiverAddressData = `
  ${
    addressDetails?.receiverAddressLine1
      ? addressDetails.receiverAddressLine1
      : ""
  }${" "}
  ${
    addressDetails?.receiverAddressLine2
      ? addressDetails?.receiverAddressLine2 + ","
      : ""
  }${" "}
 `;

  const returnAddressData = (item) => {
    return camelCase(`
    ${item?.returnAddressLine1 ? item.returnAddressLine1 + "" : ""}${" "}
    ${item?.returnAddressLine2 ? item?.returnAddressLine2 + "" : ""}${" "}
    `);
  };

  const columns = [
    {
      title: "Document No.",
      dataIndex: "childAwbNumber",
      key: "childAwbNumber",
      width: 200,
    },
    {
      title: "Weight (Kg)",
      dataIndex: "weight",
      key: "weight",
      width: 120,
    },
    {
      title: "Length",
      dataIndex: "length",
      key: "length",
      width: 120,
    },
    {
      title: "Width",
      dataIndex: "width",
      key: "width",
      width: 120,
    },
    {
      title: "Height",
      dataIndex: "height",
      key: "height",
      width: 120,
    },

    {
      title: "Volumetric Weight (Kg)",
      dataIndex: "volumetricWeight",
      key: "volumetricWeight",
      width: 160,
    },
    // {
    //   title: "Value",
    //   dataIndex: "value",
    //   key: "value",
    // },
  ];

  const dataSource = allAppData?.childShipmentDetails?.map((data, index) => ({
    key: index, // Ant Design requires a unique key for each row
    childAwbNumber: data?.childAwbNumber,
    weight: data?.weight,
    width: data?.width,
    length: data?.length,
    height: data?.height,

    volumetricWeight: data?.volumetricWeight,
    value: data?.value,
  }));

  const getCPName = JSON.parse(localStorage.getItem("userId"))?.premises;
  return (
    <div className="modal-content">
      {/* <img src={appLogo} style={{ marginBottom: "10px" }} /> */}
      <Row>
        <Col span={24}>
          <Row>
            <div className="title highlight">
              <h4>{constantsMsgs?.BOOKING_DETAILS}</h4>
            </div>
          </Row>
          <Row className="booking-details">
            <Col md={8} lg={8} xs={12} sm={12}>
              <div className="col">
                <p>
                  Document No. &nbsp;&nbsp;&nbsp;{"  "}
                  <span className="highlight">{allAppData?.awbNumber}</span>
                </p>
              </div>
              <div>
                <p>
                  {constantsMsgs?.BOOKING_FROM} :&nbsp;&nbsp;&nbsp;{"  "}
                  <span className="highlight">
                    {camelCase(getCPName?.premiseName)}
                  </span>
                </p>{" "}
              </div>
            </Col>
            <Col md={14} lg={14} xs={12} sm={12}>
              <div className="col">
                <p>
                  {constantsMsgs?.BOOKING_DATE}&nbsp;{" "}
                  <span className="highlight">
                    {formatDateTimeGlobal(
                      allAppData?.shipmentDetails?.bookingCompleteTime
                    )}
                    {/* ?.split(" ")[0]
                      ?.split("-")
                      ?.reverse()
                      ?.join("-") */}
                  </span>
                </p>
              </div>
              {/* <div>
                <p>{constantsMsgs?.BOOKING_TO}</p>{" "}
              </div> */}
              <div className="highlight">
                {camelCase(allAppData?.destinationCpName)}
              </div>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row className="address" gutter={16}>
        <Col>
          <Row>
            <div className="title">
              <h4>Address</h4>
            </div>
          </Row>
          <Row>
            <Col md={12} lg={12} sm={24} xs={24}>
              <div className="highlight">
                Sender Address{" "}
                {allAppData?.returnAddressDetail?.length == 0 &&
                  "/ Return Address"}
                {capitalise(addressDetails?.returnAddressDetail)}
              </div>
              <div className="card ">
                <div>
                  <h4>{addressDetails?.senderName}</h4>
                </div>
                <div>
                  <p>{camelCase(senderAddressData)}</p>

                  {addressDetails?.senderArea && (
                    <p>Area: {addressDetails?.senderArea}</p>
                  )}
                  <p>
                    {" "}
                    {addressDetails?.senderCity
                      ? addressDetails.senderCity + ", "
                      : " "}
                    {addressDetails?.senderState
                      ? addressDetails.senderState + ", "
                      : " "}
                    {addressDetails?.senderPincode || " "}
                  </p>

                  <p>Phone: {addressDetails?.senderMobileNumber}</p>
                </div>
              </div>
            </Col>
            <Col md={12} lg={12} sm={24} xs={24}>
              <div className="pl-05 highlight">Receiver Address</div>

              <div className="card card-one">
                <div>
                  <h4>{addressDetails?.receiverName}</h4>
                </div>
                <div>
                  <p>{camelCase(receiverAddressData)}</p>
                  <p>
                    {addressDetails?.receiverCity
                      ? addressDetails.receiverCity + ", "
                      : ""}

                    {addressDetails?.receiverState
                      ? addressDetails.receiverState +
                        ", " +
                        addressDetails?.receiverPincode
                      : null}
                  </p>
                  {addressDetails?.receiverAreaName && (
                    <p>Area: {addressDetails?.receiverAreaName}</p>
                  )}
                  <p>Phone : {addressDetails?.receiverMobileNumber || "N/A"}</p>
                </div>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
      {returnAddress?.length > 0 && (
        <>
          <Row className="address" gutter={16}>
            <Col>
              <div className="title">
                <h4>Return Address</h4>
              </div>

              <Row>
                {returnAddress?.map((item, i) => (
                  <Col md={12} lg={12} sm={24} xs={24} key={i}>
                    <div className="card card-one">
                      <div>
                        <h4>{item?.returnName}</h4>
                      </div>
                      <div>
                        <p>{returnAddressData(item)}</p>
                        <p>Area: {item?.returnAreaName || "N/A"}</p>
                        <p>
                          {item?.returnCity ? item.returnCity + "," : ""}
                          {item?.returnState ? item.returnState + "," : ""}
                          {item?.returnPincode || ""}
                        </p>
                        <p>Phone: {item?.returnMobileNumber || "N/A"}</p>
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>
        </>
      )}
      <Row className="service">
        <Col span={24}>
          <Row>
            <div className="title">
              <h4>Service Details</h4>
            </div>
          </Row>
        </Col>
      </Row>
      <Row>
        {allAppData?.shipmentDetails?.type.toLowerCase() === "dox" ? (
          <ServiceSummary
            allAppData={allAppData}
            creditCharges={creditCharges}
          />
        ) : (
          <ServiceNonDox
            allAppData={allAppData}
            creditCharges={creditCharges}
          />
        )}
      </Row>
      {allAppData?.childShipmentDetails?.length > 0 ? (
        <Row className="payment">
          <Col span={24}>
            <Row>
              <div className="title">
                <h4>Child Details</h4>
              </div>
            </Row>
            <Row>
              {/* {allAppData?.childShipmentDetails?.map((data, index) => (
                <Col md={12} lg={12} sm={24} xs={24} key={index}>
                  <div className="card left-card">
                    <Row>
                      <Col span={12} className="key">
                        <p>Document No. : </p>
                        <p>Weight (Kg):</p>
                        <p>Vol weight (Kg): </p>
                        <p>Value :</p>
                      </Col>
                      <Col span={12} className="value">
                        <p>{data?.childAwbNumber}</p>
                        <p>{data?.weight}</p>
                        <p>{data?.volumetricWeight}</p>
                        <p>{data?.value}</p>
                      </Col>
                    </Row>
                  </div>
                </Col>
              ))} */}
              <div className="mt-1">
                <Table
                  columns={columns}
                  dataSource={dataSource}
                  pagination={false} // Remove this if you want pagination
                  bordered
                />
              </div>
            </Row>
          </Col>
        </Row>
      ) : null}
      {/* {allAppData?.charges !== null && ( */}
      {bookingType == "retail" || bookingType == "Cash" ? (
        <Row className="payment">
          <Col span={24}>
            <Row>
              <div className="title">
                <h4>Total charges:</h4>
              </div>
            </Row>
            <Row>
              <Col md={12} lg={12} sm={24} xs={24}>
                <div className="card left-card">
                  <Row>
                    <Col span={12} className="key">
                      {/* <p>Total charges: </p> */}
                      <p className=""> Payment mode </p>
                      <p>SGST @ 9% : </p>
                      <p className="">CGST @ 9% : </p>
                      <p className=""> FOV </p>
                      <p className=""> BASE CHARGE </p>

                      <p className="last"> CESS </p>
                    </Col>
                    <Col span={12} className="value">
                      {/* <p>{allAppData?.charges?.charges || "NA"}</p> */}
                      <p>
                        {allAppData?.shipmentDetails?.modeOfPayment
                          ? allAppData?.shipmentDetails?.modeOfPayment?.toUpperCase()
                          : "N/A"}
                      </p>
                      <p>
                        {allAppData?.charges?.sgst
                          ? allAppData?.charges?.sgst
                          : "00.00"}
                      </p>
                      <p>
                        {allAppData?.charges?.cgst
                          ? allAppData?.charges?.cgst
                          : "00.00"}
                      </p>
                      <p>
                        {allAppData?.charges?.fov
                          ? allAppData?.charges?.fov
                          : "00.00"}
                      </p>
                      <p>
                        {allAppData?.charges?.basecharge
                          ? allAppData?.charges?.basecharge
                          : "00.00"}
                      </p>

                      <p className="last">
                        {allAppData?.charges?.cess
                          ? allAppData?.charges?.cess
                          : "00.00"}
                      </p>
                    </Col>
                  </Row>
                </div>
              </Col>
              <Col md={12} lg={12} sm={24} xs={24}>
                <div className="card right-card">
                  <Row>
                    <Col span={12} className="key">
                      {allAppData?.charges?.igst > 0 && (
                        <p> {constantsMsgs?.IGST}: </p>
                      )}
                      <p>Insured: </p>
                      <p> Packet charge : </p>
                      <p> Invoice Num : </p>

                      <p id=""> Freight :</p>
                    </Col>
                    <Col span={12} className="value">
                      {allAppData?.charges?.igst > 0 && (
                        <p>{allAppData?.charges?.igst}</p>
                      )}
                      <p>
                        {allAppData?.shipmentDetails?.insured
                          ? allAppData?.shipmentDetails?.insured == true
                            ? "YES"
                            : "No"
                          : "NO"}
                      </p>
                      <p>
                        {allAppData?.charges?.packagingCharge
                          ? allAppData?.charges?.packagingCharge
                          : "00.00"}
                      </p>
                      <p>
                        {allAppData?.charges?.invoiceNumber
                          ? allAppData?.charges?.invoiceNumber
                          : "N/A"}
                      </p>
                      <p id="">
                        {allAppData?.charges?.freight ||
                          allAppData?.charges?.amount ||
                          "0.00"}
                      </p>
                    </Col>

                    <Col className="frieght-class">
                      <p id="frieght"> Total :</p>
                      <p id="frieghtValue">
                        {allAppData?.charges?.totalCharge || "0.00"}
                      </p>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </Col>
          {/* <Col className="frieght-class">
            <p id="frieght"> Freight :</p>
            <p id="frieghtValue">{allAppData?.charges?.freight}</p>
          </Col> */}
        </Row>
      ) : null}
      {/* {allAppData?.shipmentDetails?.bookingStatus?.toUpperCase() ===
        "COMPLETED" &&
      allAppData?.shipmentDetails?.bookingType?.toUpperCase() !== "CASH" ? (
        <div
          className="button-footer mt-1"
          style={{ position: "relative", float: "right" }}
        >
          <Button
            onClick={cancelBooking}
            className="cancel-btn"
            style={{ position: "block" }}
            // disabled={inputState}
          >
            CANCEL BOOKING
          </Button>
        </div>
      ) : null} */}
    </div>
  );
};

export default Dox;
